import styles from "./Widget.module.css";
import { Tooltip } from "../tooltip/Tooltip";
import Head from '../../assets/faceLeora.png'
import { useIsMobile } from "../../hooks/useIsMobile";

interface WidgetProps {
    setShowModel: (show: boolean) => void;
    hideTooltip: boolean;
    setHideTooltip: (hide: boolean) => void;
}

export const Widget = ({setShowModel, hideTooltip, setHideTooltip}: WidgetProps) => {

  const isMobile = useIsMobile(900);

  const handleChat = () => {
    setHideTooltip(true);
    setShowModel(true);
  }

  const closeTooltip = () => {
    setHideTooltip(true)
  }  

  return (
    <div className={styles.widgetContainer}>
      {!hideTooltip && (
        <Tooltip 
          text="Hi! I'm Leora, your AI assistant. How can I help you?"
          onClick={() => setShowModel(true)}
          showCloseButton={true}
          onClose={closeTooltip}
          isTop={true}
          right={20}
          bottom={60}
          width={isMobile ? 212 : 240}
          padding={isMobile ? '0px 10px 16px' : '0px 10px 18px'}
          margin={'0px 0px 10px'}
        />
      )}
      <div className={styles.widgetWrapper}>
        <button className={styles.buttonWrapper} onClick={handleChat}>
            <img 
              src={Head}
              alt="Assistent icon" 
              className={styles.iconButton}
            />
        </button>
      </div>
    </div>
  )
}